import styled, { css } from 'styled-components'

const DividerElement = styled.div`
  background-color: #ddddde;

  ${(props) =>
    props.vertical
      ? css`
          width: ${props.density || 1}px;
          height: 100%;
          margin: 0 0.8rem;
        `
      : css`
          width: 100%;
          height: ${props.density || 1}px;
          margin: 0.8rem 0;
        `}
`

export default DividerElement
